var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-title_auxiliaryDecoration"},[_c('div',[_c('span',{staticClass:"w-text_auxiliaryDecoration"},[_vm._v(_vm._s(_vm.xText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }